import {
  ApiResponse,
  CLIENT_ERROR,
  CONNECTION_ERROR,
  NETWORK_ERROR,
  PROBLEM_CODE,
  SERVER_ERROR,
  TIMEOUT_ERROR,
} from 'apisauce';
import {
  ClientError,
  ClientNetworkError,
  ClientRequestError,
  ClientServerError,
  ClientTimeoutError,
} from '~domain/error';

/**
 * Interface for all request error handlers
 */
export interface RequestErrorHandler {
  handleRequestError<T>(problem: PROBLEM_CODE, response: ApiResponse<T>): void;
}

/**
 * Base class for all request error handler.
 * This is the default class used for clients
 */
export class BaseRequestErrorHandler implements RequestErrorHandler {
  handleRequestError<T>(problem: PROBLEM_CODE, response: ApiResponse<T>) {
    if (problem === CLIENT_ERROR) {
      throw new ClientRequestError(response.status, response.data);
    }

    if (problem === SERVER_ERROR) {
      throw new ClientServerError(response.status, response.data);
    }

    if (problem === CONNECTION_ERROR || problem === NETWORK_ERROR) {
      throw new ClientNetworkError();
    }

    if (problem === TIMEOUT_ERROR) {
      throw new ClientTimeoutError();
    }

    throw new ClientError();
  }
}
